import { combineReducers, configureStore } from '@reduxjs/toolkit';
import api from '../services/api';
import authSlice, { IauthInitState } from './authSlice';
import importsSlice, { TImportsInitState } from './importsSlice';
import sseSlice, { ISseInitState } from './sseSlice';

export interface IInitReduxState {
  authSlice?: IauthInitState;
  importsSlice?: TImportsInitState;
  sseSlice?: ISseInitState;
}

const rootReducer = combineReducers({
  [api.reducerPath]: api.reducer,
  authSlice,
  importsSlice,
  sseSlice,
});

// Redux store with initial state (for testing)
export const createReduxStore = (preloadedState?: IInitReduxState) =>
  configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(api.middleware),
    preloadedState: preloadedState || {},
  });

export const store = createReduxStore();

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
